import { config } from "../../config";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { authGet } from "../../services/RequestHelpers";
import { ICurrencyCode } from "../../components/SLCreate/SLCreateRequests";
import { IUserProviderState } from "../UserContext";

// Fiscal Year Requests

export interface IFiscalYear {
  readonly fiscalYearNumber: number;
}

export async function getFiscalYearsForEndpoint(getTokenFn: IUserProviderState["accessToken"]): Promise<IFiscalYear[]> {
  const getFiscalYearsUrl = config.get("datamallUrl") + SubledgerEndpoints.FiscalMonths;
  const result = await authGet(getFiscalYearsUrl, getTokenFn);
  const localFiscalYears = result && result.data ? result.data : [];
  return localFiscalYears as IFiscalYear[];
}

//  User Roles Requests

export interface IUserRoles {
  isAdmin: boolean;
  hasPostingAccess: boolean;
  isReadOnly: boolean;
  isReviewer: boolean;
}

export async function getUserRolesFromEndpoint(getTokenFn: IUserProviderState["accessToken"]): Promise<IUserRoles> {
  const getUserRolesUrl = config.get("subledgerUrl") + SubledgerEndpoints.roles;
  const result = await authGet(getUserRolesUrl, getTokenFn);
  const localFiscalYears = result && result.data ? result.data : [];
  return localFiscalYears as IUserRoles;
}

// Document Type Requests

export interface IDocumentType {
  readonly documentTypeCode: string;
}

export async function getDocumentTypesFromEndpoint(
  getTokenFn: IUserProviderState["accessToken"]
): Promise<IDocumentType[]> {
  const getDocumentTypesUrl = config.get("subledgerUrl") + SubledgerEndpoints.DocumentTypes;
  const result = await authGet(getDocumentTypesUrl, getTokenFn);
  return result.data as IDocumentType[];
}

// Currency Code Requests

export async function getCurrencyCodesFromEndpoint(
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ICurrencyCode[]> {
  const getCurrencyCodeUrl = config.get("datamallUrl") + SubledgerEndpoints.currencyCodesGetPath;
  const result = await authGet(getCurrencyCodeUrl, getTokenFn);
  return result.data as ICurrencyCode[];
}

// Company Code Requests

export interface ICompanyCode {
  readonly glCompanyCode: number;
  readonly glCompanyName: string;
}

export async function getCompanyCodesFromEndpoint(
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ICompanyCode[]> {
  const getCompanyCodesUrl = config.get("datamallUrl") + SubledgerEndpoints.CompanyCode;
  const result = await authGet(getCompanyCodesUrl, getTokenFn);
  return result.data as ICompanyCode[];
}

// Action Links Requests

export interface IActionLinks {
  id: number;
  action: string;
  description: string;
  weightage: number;
}

export async function getActionListsFromEndpoint(
  getTokenFn: IUserProviderState["accessToken"]
): Promise<IActionLinks[]> {
  const getActionLinksUrl = config.get("subledgerUrl") + SubledgerEndpoints.slActions + SubledgerEndpoints.slActionList;
  const response = await authGet(getActionLinksUrl, getTokenFn);
  const localActions = response && response.data && response.data.result ? response.data.result : [];
  return localActions as IActionLinks[];
}
